import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/client';
import './ConfiguracaoCalculo.css';

const ConfiguracaoCalculo = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [config, setConfig] = useState({
    percentual_caixinha: 30.00,
    itens_total_arrecadado: [],
    itens_direto_caixinha: [],
    itens_saldo_devedor: [],
    valores_fixos: {},
  });

  // Opções disponíveis para seleção
  const opcoesDisponiveis = [
    { id: 'entrada', label: 'Entrada (R$40,00)', valor: 40.00 },
    { id: 'buyin_inicial', label: 'Buy-in Inicial (R$25,00)', valor: 25.00 },
    { id: 'rebuys_simples', label: 'Rebuys Simples (R$25,00)', valor: 25.00 },
    { id: 'rebuys_duplos', label: 'Rebuys Duplos (R$40,00)', valor: 40.00 },
    { id: 'addon', label: 'Add-on (R$50,00)', valor: 50.00 },
    { id: 'janta', label: 'Janta', valor: 0 },
    { id: 'jackpot', label: 'Jackpot (R$10,00)', valor: 10.00 },
  ];

  useEffect(() => {
    carregarConfiguracao();
  }, []);

  const carregarConfiguracao = async () => {
    try {
      setLoading(true);
      const response = await api.get('/configuracao/calculo');
      setConfig(response.data);
    } catch (error) {
      console.error('Erro ao carregar configuração:', error);
      alert('Erro ao carregar configuração. Usando valores padrão.');
    } finally {
      setLoading(false);
    }
  };

  const handlePercentualChange = (e) => {
    const valor = parseFloat(e.target.value);
    if (!isNaN(valor) && valor >= 0 && valor <= 100) {
      setConfig({ ...config, percentual_caixinha: valor });
    }
  };

  const toggleItem = (arrayName, itemId) => {
    const currentArray = config[arrayName] || [];
    const newArray = currentArray.includes(itemId)
      ? currentArray.filter(id => id !== itemId)
      : [...currentArray, itemId];
    setConfig({ ...config, [arrayName]: newArray });
  };

  const handleValorFixoChange = (itemId, valor) => {
    const novoValor = parseFloat(valor);
    if (!isNaN(novoValor) && novoValor >= 0) {
      setConfig({
        ...config,
        valores_fixos: {
          ...config.valores_fixos,
          [itemId]: novoValor,
        },
      });
    }
  };

  const handleSalvar = async () => {
    try {
      setSaving(true);
      await api.put('/configuracao/calculo', config);
      alert('Configuração salva com sucesso!');
      await carregarConfiguracao();
    } catch (error) {
      console.error('Erro ao salvar configuração:', error);
      alert('Erro ao salvar configuração. Verifique os dados e tente novamente.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="configuracao-calculo-container">
        <div className="loading">Carregando configuração...</div>
      </div>
    );
  }

  return (
    <div className="configuracao-calculo-container">
      <div className="configuracao-header">
        <h1>⚙️ Lógica de Cálculo NerdzPoker</h1>
        <button className="btn-voltar" onClick={() => navigate('/admin')}>
          ← Voltar
        </button>
      </div>

      <div className="configuracao-content">
        <div className="config-section">
          <h2>📊 Percentual da Caixinha</h2>
          <div className="percentual-input">
            <label>
              Percentual do Total Arrecadado que vai para Caixinha:
              <input
                type="number"
                min="0"
                max="100"
                step="0.01"
                value={config.percentual_caixinha}
                onChange={handlePercentualChange}
              />
              <span className="percent-symbol">%</span>
            </label>
            <p className="info-text">
              Exemplo: Se o Total Arrecadado for R$ 1.000,00 e o percentual for 30%, 
              a caixinha será R$ 300,00 (menos os gastos da rodada).
            </p>
          </div>
        </div>

        <div className="config-section">
          <h2>💰 Itens que Entram no Total Arrecadado</h2>
          <p className="info-text">
            Selecione quais itens devem ser somados para calcular o Total Arrecadado da rodada.
          </p>
          <div className="checkboxes-grid">
            {opcoesDisponiveis.map(opcao => (
              <label key={opcao.id} className="checkbox-item">
                <input
                  type="checkbox"
                  checked={config.itens_total_arrecadado.includes(opcao.id)}
                  onChange={() => toggleItem('itens_total_arrecadado', opcao.id)}
                />
                <span>{opcao.label}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="config-section">
          <h2>🏦 Itens que Vão Direto para Caixinha</h2>
          <p className="info-text">
            Itens selecionados aqui <strong>NÃO</strong> entram no Total Arrecadado, 
            mas vão direto para a caixinha.
          </p>
          <div className="checkboxes-grid">
            {opcoesDisponiveis.map(opcao => (
              <label key={opcao.id} className="checkbox-item">
                <input
                  type="checkbox"
                  checked={config.itens_direto_caixinha.includes(opcao.id)}
                  onChange={() => toggleItem('itens_direto_caixinha', opcao.id)}
                />
                <span>{opcao.label}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="config-section">
          <h2>💳 Itens que Entram no Saldo Devedor</h2>
          <p className="info-text">
            Selecione quais itens devem ser somados para calcular o Saldo Devedor de cada jogador.
          </p>
          <div className="checkboxes-grid">
            {opcoesDisponiveis.map(opcao => (
              <label key={opcao.id} className="checkbox-item">
                <input
                  type="checkbox"
                  checked={config.itens_saldo_devedor.includes(opcao.id)}
                  onChange={() => toggleItem('itens_saldo_devedor', opcao.id)}
                />
                <span>{opcao.label}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="config-section">
          <h2>💵 Valores Fixos</h2>
          <p className="info-text">
            Configure os valores fixos de cada item. Estes valores serão usados nos cálculos.
          </p>
          <div className="valores-fixos-grid">
            {opcoesDisponiveis.map(opcao => (
              <div key={opcao.id} className="valor-fixo-item">
                <label>
                  {opcao.label.replace(/\(.*?\)/g, '').trim()}:
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    value={config.valores_fixos[opcao.id] || opcao.valor}
                    onChange={(e) => handleValorFixoChange(opcao.id, e.target.value)}
                  />
                </label>
              </div>
            ))}
          </div>
        </div>

        <div className="config-actions">
          <button 
            className="btn-salvar" 
            onClick={handleSalvar}
            disabled={saving}
          >
            {saving ? 'Salvando...' : '💾 Salvar Configuração'}
          </button>
        </div>

        <div className="config-warning">
          <h3>⚠️ Atenção</h3>
          <ul>
            <li>As alterações nesta tela afetarão <strong>todas as rodadas futuras</strong>.</li>
            <li>Rodadas já fechadas <strong>não serão alteradas</strong>.</li>
            <li>Certifique-se de que os valores estão corretos antes de salvar.</li>
            <li>O percentual da caixinha deve estar entre 0% e 100%.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ConfiguracaoCalculo;
